module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "form",
    attrs: {
      "model": _vm.curInput,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "记录类型"
    }
  }, [_c('el-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.user_info.default_type),
      expression: "curInput.user_info.default_type"
    }],
    domProps: {
      "value": (_vm.curInput.user_info.default_type)
    },
    on: {
      "input": function($event) {
        _vm.curInput.user_info.default_type = $event
      }
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 10
    }
  }, [_vm._v("创建人")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 20
    }
  }, [_vm._v("修改人")])])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "默认值"
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.user_info.field),
      expression: "curInput.user_info.field"
    }],
    attrs: {
      "placeholder": "请选择"
    },
    domProps: {
      "value": (_vm.curInput.user_info.field)
    },
    on: {
      "input": function($event) {
        _vm.curInput.user_info.field = $event
      }
    }
  }, _vm._l((_vm.userInfos), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.name,
        "value": item.value
      }
    })
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2a945359!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Model/configComponents/userInfoConfig.vue
// module id = 1802
// module chunks = 2